import React from 'react';
import { connect } from 'react-redux';
import TextInputNew from 'screens/components/basic/TextInputNew';
class AccountPage extends React.Component {
    constructor(p) {
        super(p);
        p.dispatch({ type: "INIT_ACCOUNTPAGE" });
    }
    render() {
        return (
            <div>
                <TextInputNew name="test123" hintText="Name" />
            </div>
        );
    }
}

export default connect()(AccountPage);